import React, { useState, useRef, useEffect } from "react";
import {
    ArrowLeft,
    Bookmark,
    Download,
    Filter,
    Search,
    SortDesc,
    Plus,
    Folder,
} from "lucide-react";
import Navbar from "../components/Navbar";
import { data, useNavigate, useParams } from "react-router-dom";
import { db, storage } from "../firebase";
import {
    collection,
    getDocs,
    query,
    where,
    doc,
    getDoc,
    updateDoc,
    arrayUnion,
} from "firebase/firestore";
import { auth } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import toast from "react-hot-toast";
const initialCaseData = {
    status: "",
    caseNumber: "",
    caseType: "",
    caseYear: "",
    caseFiledDate: null,
    nextHearingDate: null,
    previousHearingDate: null,
    appearingFor: "",
    court: "",
    customCourt: "",
    petitionerName: "",
    respondentName: "",
    partyContactNumber: "",
    caseNotes: "",
    files: [],
};


function FilesSection({ onBackClick, id }) {
    const navigation = useNavigate(); // Extract case id from URL
    const [searchTerm, setSearchTerm] = useState("");
    // const { id } = useParams();
    const [isUploading, setIsUploading] = useState(false);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [caseData, setCaseData] = useState(initialCaseData); // State for case data
    const fileInputRef = useRef(null);
    const [userEmail, setUserEmail] = useState(null);
    const [sortList, setSortList] = useState(false);
    const [newToOld, setNewToOld] = useState(false);
    const [oldToNew, setOldToNew] = useState(false);
    const [renderList, setrenderList] = useState([]);
    const [showBookmark, setShowBookmark] = useState(false);
    const [bookmark, setbookmark] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const user = auth.currentUser;
                if (!user) {
                    setError("User not authenticated.");
                    setLoading(false);
                    return;
                }
                const uid = user.uid;

                // Fetch case details and files
                const pendingCaseDoc = doc(db, "pending", id);
                const disposedCaseDoc = doc(db, "disposed", id);
                const pendingCaseSnapshot = await getDoc(pendingCaseDoc);
                let data;
                if (pendingCaseSnapshot.exists()) {
                    data = pendingCaseSnapshot.data();
                } else {
                    const disposedCaseSnapshot = await getDoc(disposedCaseDoc);
                    if (disposedCaseSnapshot.exists()) {
                        data = disposedCaseSnapshot.data();
                    } else {
                        setError("No such case found!");
                        setCaseData(null);
                        setFiles([]);
                        setrenderList([]);
                        setLoading(false);
                        return;
                    }
                }

                // Check if user has access: owner or in savedByTeamMember
                if (data.owner === uid || (data.savedByTeamMember && data.savedByTeamMember.includes(uid))) {
                    setCaseData({
                        caseNumber: data.caseNo,
                        caseName: data.caseType,
                        partyName: data.petitionerName,
                        bookmark: data.bookmark || []
                    });
                    setFiles(data.files || []); // Set files directly from the case document
                    setrenderList(data.files || []);
                    setbookmark(data.bookmarkArr || []);
                } else {
                    setError("You do not have permission to view this case's files.");
                    setCaseData(null);
                    setFiles([]);
                    setrenderList([]);
                }

                // Optionally fetch user email (if you want to keep it)
                const lawyersCollectionRef = collection(db, "lawyers");
                const emailQuery = query(lawyersCollectionRef, where("uid", "==", uid));
                const emailSnapshot = await getDocs(emailQuery);
                if (!emailSnapshot.empty) {
                    setUserEmail(emailSnapshot.docs[0].data().email);
                } else {
                    setUserEmail("Email not found");
                }
            } catch (err) {
                setError(`Failed to load data. Error: ${err.message || "Unknown error"}`);
                setCaseData(null);
                setFiles([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();



    }, [id]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);


    const handleFileUpload = async (e) => {

        if (e.target.files) {
            const filesArray = Array.from(e.target.files);
            const uploadPromises = filesArray.map(async (file) => {
                const storageRef = ref(storage, `case-file/${Date.now()}-${file.name}`);

                const toastId = toast.loading(`Uploading ${file.name}...`);

                try {
                    await uploadBytes(storageRef, file);
                    const url = await getDownloadURL(storageRef);
                    toast.success(`${file.name} uploaded successfully`, { id: toastId });
                    return url;
                } catch (error) {
                    console.error("upload error", error)
                    toast.error(`Failed to Upload ${file.name}`, { id: toastId })
                    return null;
                }
            });
            const urls = (await Promise.all(uploadPromises)).filter((url) => url !== null);
            // setCaseData((prev) => ({ ...prev, files: [...prev.files, ...urls] }));
            setFiles((prev) => ([...prev, ...urls]))
            const pendingCaseDoc = doc(db, "pending", id);
            const disposedCaseDoc = doc(db, "disposed", id);
            const pendingCaseSnapshot = await getDoc(pendingCaseDoc);
            const disposedCaseSnapshot = await getDoc(disposedCaseDoc);

            if (pendingCaseSnapshot.exists()) {

                await updateDoc(doc(db, "pending", id), {
                    files: arrayUnion(...urls)

                })
            } else if (disposedCaseSnapshot.exists()) {
                await updateDoc(doc(db, "disposed", id), {
                    files: arrayUnion(...urls)

                })
            }
        }
    };

    const handleViewFile = (fileUrl) => {
        if (fileUrl) {
            window.open(fileUrl, "_blank", "noopener,noreferrer");
        }
    };

    const handleDownloadFile = (fileUrl) => {
        if (fileUrl) {
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = ""; // Let browser decide the filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleSortClick = () => {
        setSortList(!sortList);
    }
    const extractTimestamp = (url) => {
        const regex = /\/case-file%2F(\d+)-/;
        const match = url.match(regex);
        return match ? Number(match[1]) : 0;
    };

    const handleNewToOld = () => {
        const sortState = !newToOld;
        setNewToOld(sortState);
        setOldToNew(false)
        setSortList(false)
        if (sortState) {
            const sortedfiles = [...renderList].sort((a, b) => {
                const timeA = extractTimestamp(a);
                const timeB = extractTimestamp(b);

                return timeB - timeA
            });
            setrenderList(sortedfiles);
        }
        else {
            setrenderList(files)
        }

    }
    const handleOldToNew = () => {
        const sortState = !oldToNew;
        setOldToNew(sortState);
        setNewToOld(false);
        setSortList(false);
        if (sortState) {
            const sortedfiles = [...renderList].sort((a, b) => {
                const timeA = extractTimestamp(a);
                const timeB = extractTimestamp(b);
                return timeA - timeB;
            });
            setrenderList(sortedfiles);
        }
        else {
            setrenderList(files)
        }
    }

    const handleBookmarkSorting = () => {
        const bookmarkSt = !showBookmark;
        setShowBookmark(bookmarkSt);
        if (bookmarkSt) {
            setrenderList(bookmark);
        }
        else {
            setrenderList(files);
        }

    }

    const handleBookmark = async (url) => {

        const pendingCaseDoc = doc(db, "pending", id);
        const disposedCaseDoc = doc(db, "disposed", id);
        const pendingCaseSnapshot = await getDoc(pendingCaseDoc);
        const disposedCaseSnapshot = await getDoc(disposedCaseDoc);


        if (pendingCaseSnapshot.exists()) {
            const data = pendingCaseSnapshot.data();
            const files = data.bookmarkArr || [];
            if (files.includes(url)) {
                const updatedfiles = files.filter((item) => item !== url)
                console.log(updatedfiles)
                setbookmark(updatedfiles)
                await updateDoc(pendingCaseDoc, { bookmarkArr: updatedfiles })
            } else {
                const updatedFiles = [...files, url];
                setbookmark(updatedFiles);
                await updateDoc(pendingCaseDoc, { bookmarkArr: updatedFiles })
            }


        } else if (disposedCaseSnapshot.exists()) {
            const data = disposedCaseSnapshot.data();
            const files = data.bookmarkArr || [];
            if (files.includes(url)) {
                const updatedfiles = files.filter((item) => item !== url)
                setbookmark(updatedfiles)
                await updateDoc(disposedCaseDoc, { bookmark: updatedfiles })
            } else {
                const updatedFiles = [...files, url];
                setbookmark(updatedFiles);
                await updateDoc(disposedCaseDoc, { bookmark: updatedFiles })
            }

        }

    }

    console.log(files)

    return (
        <div className=" fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-[1002] ">
            <div className="bg-[#0c0a29] text-white p-8 relative ">


                <div className="max-w-6xl mx-auto">
                    {/* Header */}
                    <div className="flex items-center mb-8">
                        <button
                            className="flex items-center text-white"
                            onClick={onBackClick}
                        >
                            <ArrowLeft className="w-6 h-6 mr-4" />
                            <h1 className="text-2xl font-bold text-[#FFB800]">Case Files</h1>
                        </button>
                    </div>

                    {/* Search and Filters */}
                    {/* <div className="flex justify-between items-center mb-8">
                        <div className="relative w-64">
                            <input
                                type="text"
                                placeholder="Search Files"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full bg-[#1A1438] text-white pl-10 pr-4 py-2 rounded-lg"
                            />
                            <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                        </div>
                        <div className="relative flex gap-4 ml-4">
                            <button className={`flex items-center gap-2 ${showBookmark ? "text-blue-500" : "text-white"}`} onClick={handleBookmarkSorting}>
                                <Bookmark className="w-4 h-4" /> Bookmarks
                            </button>
                            <button className="flex items-center gap-2 text-white">
                                <Filter className="w-4 h-4" /> Filter
                            </button>

                            <button className="flex items-center gap-2 text-white" onClick={handleSortClick}>
                                <SortDesc className="w-4 h-4" /> Sort
                            </button>
                            {sortList && <ul className="absolute z-50 px-2 py-2 bg-black top-[100%] right-[-20px]  w-fit text-xs rounded">
                                <li className={`px-2 py-1 border-b-[1px] border-white ${newToOld ? "text-blue-400" : "text-white"} hover:text-blue-400 cursor-pointer`} onClick={handleNewToOld}>Newest To Oldest</li>
                                <li className={`px-2 py-1 ${oldToNew ? "text-blue-400" : "text-white"} hover:text-blue-400 cursor-pointer`} onClick={handleOldToNew}>Oldest to Newest</li>
                            </ul>}


                        </div>
                    </div> */}

                    <div className="bg-[#2A2544] rounded-lg p-6">
                        {loading && <p className="text-center text-gray-300">Loading files...</p>}
                        {error && <p className="text-center text-red-500">{error}</p>}
                        {!loading && !error && caseData && (
                            <>
                                {/* Display case info once */}
                                <div className="mb-2">
                                    <h2 className="text-2xl font-bold text-[#FFB800] mb-[20px]">Case No: {caseData.caseNumber}</h2>
                                    <div className="flex justify-between items-center mb-8">
                                        <div className="relative w-64">
                                            <input
                                                type="text"
                                                placeholder="Search Files"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="w-full bg-[#1A1438] text-white pl-10 pr-4 py-2 rounded-lg"
                                            />
                                            <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                                        </div>
                                        <div className="relative flex gap-4 ml-4">
                                            <button className={`flex items-center gap-2 ${showBookmark ? "text-blue-500" : "text-white"}`} onClick={handleBookmarkSorting}>
                                                <Bookmark className="w-4 h-4" /> Bookmarks
                                            </button>
                                            <button className="flex items-center gap-2 text-white">
                                                <Filter className="w-4 h-4" /> Filter
                                            </button>

                                            <button className="flex items-center gap-2 text-white" onClick={handleSortClick}>
                                                <SortDesc className="w-4 h-4" /> Sort
                                            </button>
                                            {sortList && <ul className="absolute z-50 px-2 py-2 bg-black top-[100%] right-[-20px]  w-fit text-xs rounded">
                                                <li className={`px-2 py-1 border-b-[1px] border-white ${newToOld ? "text-blue-400" : "text-white"} hover:text-blue-400 cursor-pointer`} onClick={handleNewToOld}>Newest To Oldest</li>
                                                <li className={`px-2 py-1 ${oldToNew ? "text-blue-400" : "text-white"} hover:text-blue-400 cursor-pointer`} onClick={handleOldToNew}>Oldest to Newest</li>
                                            </ul>}


                                        </div>
                                    </div>
                                </div>
                                {/* File list */}
                                {renderList.length === 0 ? (
                                    <p className="text-center text-gray-400">No files found for this case.</p>
                                ) : (
                                    renderList
                                        .filter((fileUrl) =>
                                            searchTerm === "" ||
                                            fileUrl.toLowerCase().includes(searchTerm.toLowerCase())
                                        )
                                        .map((fileUrl, index) => (
                                            <div
                                                key={index}
                                                className="flex items-center justify-between py-4 px-2 border-b border-gray-700 last:border-b-0"
                                            >
                                                <div className="flex items-center gap-4">
                                                    <Folder size={24} color="#FFD700" strokeWidth={1.5} />
                                                    <span className="text-white mr-[10px]">
                                                        {fileUrl.split('/').pop().split('?')[0] || "Unnamed File"}
                                                    </span>
                                                </div>
                                                <div className="flex gap-4">
                                                    <button
                                                        className="bg-white text-black px-6 py-2 rounded-lg"
                                                        onClick={() => handleViewFile(fileUrl)}
                                                    >
                                                        View
                                                    </button>
                                                    <button
                                                        className="bg-white text-black px-6 py-2 rounded-lg flex items-center gap-2"
                                                        onClick={() => handleDownloadFile(fileUrl)}
                                                    >
                                                        <Download className="w-4 h-4" /> Download
                                                    </button>
                                                    <button className="bg-white text-black p-2 rounded-lg" onClick={() => { handleBookmark(fileUrl) }}>
                                                        {/* <Bookmark className="w-4 h-4" /> */}
                                                        {bookmark.includes(fileUrl) ? <i className="fa-solid fa-bookmark"></i> : <i className="fa-regular fa-bookmark" ></i>}
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                )}
                            </>
                        )}
                    </div>

                    {/* <div className="w-16 h-16 flex items-center justify-center">
                    <Folder size={98} color="#FFD700" strokeWidth={1.5} />
                  </div>
                  <div class="flex-1 space-y-2">
                    <div>
                      <span className="text-gray-400">Email:</span>{" "}
                      {userEmail || "N/A"}
                    </div>
                    <div>
                      <span className="text-gray-400">Case Number:</span>{" "}
                      {caseData.caseNumber || "N/A"}
                    </div>
                    <div>
                      <span className="text-gray-400">Case Name:</span>{" "}
                      {caseData.caseName || "N/A"}
                    </div>
                    <div>
                      <span className="text-gray-400">Party Name:</span>{" "}
                      {caseData.partyName || "N/A"}
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <button
                      className="bg-white text-black px-6 py-2 rounded-lg"
                      onClick={() => handleViewFile(fileData.files[0])}
                    >
                      View
                    </button>
                    <button
                      className="bg-white text-black px-6 py-2 rounded-lg flex items-center gap-2"
                      onClick={() => handleDownloadFile(fileData.files[0])}
                    >
                      <Download className="w-4 h-4" /> Download
                    </button>
                    <button className="bg-white text-black p-2 rounded-lg">
                      <Bookmark className="w-4 h-4" />
                    </button>
                  </div> */}
                    {/* </div>
              ))}
          </div> */}

                    {/* Upload Button */}
                    {/* <div className="fixed bottom-8 right-8">
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            className="hidden"
                            multiple
                        />
                        <button
                            onClick={() => fileInputRef.current?.click()}
                            className="bg-[#FFB800] text-black p-4 rounded-full shadow-lg hover:bg-[#ffc93c] transition-all duration-300 flex items-center justify-center"
                            disabled={isUploading}
                        >
                            {isUploading ? (
                                <div className="w-6 h-6 border-2 border-black border-t-transparent rounded-full animate-spin" />
                            ) : (
                                <Plus className="w-6 h-6" />
                            )}
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default FilesSection;

























